import gql from 'graphql-tag';
import apiv2Client from '@/apiv2Client';
import { colonyAPI } from '@/api';

import * as types from './mutation-types';

export default {
  getSurveyCharts({ commit }, surveyId) {
    commit(types.GET_SURVEY_CHARTS_REQUEST);

    colonyAPI
      .post('/analytics/surveys/', { survey_id: surveyId, filter_by: 'survey' })
      .then(response => commit(types.GET_SURVEY_CHARTS_SUCCESS, response))
      .catch(error => commit(types.GET_SURVEY_CHARTS_FAILURE, error));
  },

  getSpotCharts({ commit }) {
    commit(types.GET_SPOT_CHARTS_REQUEST);

    colonyAPI
      .get('/analytics/surveys/spots/')
      .then(response => commit(types.GET_SPOT_CHARTS_SUCCESS, response))
      .catch(error => commit(types.GET_SPOT_CHARTS_FAILURE, error));
  },

  getPeriodCharts({ commit }, { period, date }) {
    commit(types.GET_SURVEY_CHARTS_REQUEST);

    colonyAPI
      .post('/analytics/surveys/', { filter_by: 'period', period, date })
      .then(response => commit(types.GET_SURVEY_CHARTS_SUCCESS, response))
      .catch(error => commit(types.GET_SURVEY_CHARTS_FAILURE, error));
  },

  getSurveys({ commit }) {
    commit(types.GET_SURVEYS_REQUEST);

    colonyAPI
      .get('/surveys/list/')
      .then(response => commit(types.GET_SURVEYS_SUCCESS, response))
      .catch(error => commit(types.GET_SURVEYS_FAILURE, error));
  },

  getPeriods({ commit }) {
    commit(types.GET_PERIODS_REQUEST);

    colonyAPI
      .get('/analytics/surveys/periods/')
      .then(response => commit(types.GET_PERIODS_SUCCESS, response))
      .catch(error => commit(types.GET_PERIODS_FAILURE, error));
  },

  getSurveyAnswerGroups({ commit }) {
    commit(types.GET_SURVEY_ANSWER_GROUPS_REQUEST);

    colonyAPI
      .get('/analytics/surveys/answer-groups/')
      .then(response => commit(types.GET_SURVEY_ANSWER_GROUPS_SUCCESS, response))
      .catch(error => commit(types.GET_SURVEY_ANSWER_GROUPS_FAILURE, error));
  },
  createSpotSurvey(
    { commit, dispatch },
    { title, campaignId, startDate, endDate, redirectUrl, logoUrl, questions, profiles },
  ) {
    commit(types.CREATE_SPOT_REQUEST);

    const postData = {
      title,
      campaign_id: campaignId,
      questions,
      profiles,
      start_date: startDate,
      end_date: endDate,
      redirect_url: redirectUrl,
      logo_url: logoUrl,
    };

    colonyAPI
      .post('/surveys/spots/', postData)
      .then(response => {
        dispatch('getSpotCharts');
        commit(types.CREATE_SPOT_SUCCESS, response.data);
      })
      .catch(error => commit(types.CREATE_SPOT_FAILURE, error));
  },

  getDemographics({ commit }) {
    commit(types.GET_SURVEY_DEMOGRAPHICS_REQUEST);

    colonyAPI
      .get('/surveys/demographics/')
      .then(response => commit(types.GET_SURVEY_DEMOGRAPHICS_SUCCESS, response.data))
      .catch(error => commit(types.GET_SURVEY_DEMOGRAPHICS_FAILURE, error));
  },


  async getRespondents({ state, commit }, filter) {
    commit(types.GET_SURVEY_RESPONDENTS_REQUEST);

    try {
      const res = await apiv2Client.query({
        query: gql`
          query($surveyId: Int, $questionId: Int, $choiceId: Int, $page: Int) {
            getQuestionChoiceRespondents(surveyId: $surveyId, questionId: $questionId, choiceId: $choiceId, page: $page) {
              entries {
                mobileNumber
                dateAnswered
                fingerprint
                id
                surveyId
                answer {
                  id
                  choice {
                    id
                    title
                  }
                  choices {
                    id
                    title
                  }
                  choiceId
                  question {
                    id
                    title
                    questionType
                    chart
                    categoryId
                    insight
                    isRequired
                    isGlobal
                    isProfile
                    isAnalytics
                    profileField
                  }
                  questionId
                  input
                }
              }
              pageNumber
              pageSize
              totalEntries
              totalPages
            }
          }
        `,
        variables: {
          surveyId: filter.survey_id,
          questionId: filter.question_id,
          choiceId: filter.choice_id,
          page: state.respondentMoreUrl,
        },
      });
      const respondents = res.data.getQuestionChoiceRespondents;
      commit(types.GET_SURVEY_RESPONDENTS_SUCCESS, respondents);
    } catch (error) {
      commit(types.GET_SURVEY_RESPONDENTS_FAILURE, error);
    }
  },


  getMoreRespondents({ state, commit }) {
    commit(types.GET_SURVEY_RESPONDENTS_REQUEST);

    colonyAPI
      .get(state.respondentMoreUrl)
      .then(response => commit(types.GET_SURVEY_RESPONDENTS_SUCCESS, response.data))
      .catch(error => commit(types.GET_SURVEY_RESPONDENTS_FAILURE, error));
  },

  downloadSurveyReport({ commit, dispatch }, surveyId) {
    commit(types.DOWNLOAD_SURVEY_RESPONSES_REQUEST);

    colonyAPI
      .get(`/surveys/download/${surveyId}/`)
      .then(() => {
        commit(types.DOWNLOAD_SURVEY_RESPONSES_SUCCESS);
        dispatch(
          'toast/success',
          'Your request has been successfully received. You will be notified when the file is ready to download.',
          { root: true },
        );
      })
      .catch(error => {
        commit(types.DOWNLOAD_SURVEY_RESPONSES_FAILURE, error);
        dispatch(
          'toast/error',
          'Your request to download messages failed. Please contact support for more help.',
          { root: true },
        );
      });
  },
  surveyReport({ commit, dispatch }, surveyId) {
    commit(types.DOWNLOAD_SURVEY_RESPONSES_REQUEST);

    colonyAPI
      .get(`/surveys/download-survey/${surveyId}/`)
      .then(() => {
        commit(types.DOWNLOAD_SURVEY_RESPONSES_SUCCESS);
        dispatch(
          'toast/success',
          'Your request has been successfully received. You will be notified when the file is ready to download.',
          { root: true },
        );
      })
      .catch(error => {
        commit(types.DOWNLOAD_SURVEY_RESPONSES_FAILURE, error);
        dispatch(
          'toast/error',
          'Your request to download messages failed. Please contact support for more help.',
          { root: true },
        );
      });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/survey/actions.js